/**
 * 根据用户名搜索用户信息。
 *
 * @param user - 要搜索的用户名。
 * @param page - 可选参数，搜索结果页码，默认为第一页。
 * @param size - 可选参数，每页的搜索结果数量，默认为 10 条。
 * @returns 包含搜索结果的 Promise。
 */
export async function fetchUserByUsername(
  user: string,
  page = 1,
  size = 10
): Promise<{ total: number; list: Search.User[] }> {
  // 发起 HTTP GET 请求搜索用户信息
  return http
    .get<{
      total: number
      list: Search.User[]
    }>('/v1/search/user', {
      user,
      page,
      size
    })
    .then((res) => res.data || { total: 0, list: [] })
    .catch(() => ({ total: 0, list: [] as Search.User[] }))
}
